import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useSurvey from 'hooks/useSurvey';
import { SurveyQuestion } from '../model/SurveyModel';
import CommuncationSurveyContent from './CommunicationSurveyContent';

// todo:
// 1. Thank You screen OK
// 2. Save data OK
// 3. Homepage notice OK
// 4. Validation NOT NEEDED
// 5. Desktop design OK
// 6. Fill data

type SurveyContextType = {
  current: SurveyQuestion | null;
  prevStep: string | null;
  nextStep: string | null;
  stepNo: number;
  allSteps: number;
  addResponses: (responses: Record<string, string | string[]>) => void;
  saveResponses: (data) => void;
  responses: Record<string, any>;
}

const SurveyContext = createContext<SurveyContextType>({
  current: null,
  prevStep: null,
  nextStep: null,
  stepNo: -1,
  allSteps: 0,
  addResponses: () => {},
  saveResponses: () => {},
  responses: null,
});

function useSurveyContext() {
  return useContext(SurveyContext);
}

export const HostCommunicationSurveyKey = 'hostcoms'
function SurveyContextProvider({ children }) {
  const { storeResponses } = useSurvey(HostCommunicationSurveyKey);
  const [responses, setResponses] = useState({});

  const [state, setState] = useState({
    current: null,
    prevStep: null,
    nextStep: CommuncationSurveyContent[0].name,
    stepNo: -1,
    allSteps: CommuncationSurveyContent.length,
  });
  const location = useLocation();

  useEffect(() => {
    const allSteps = CommuncationSurveyContent.length;
    const newState = {
      current: null,
      prevStep: null,
      nextStep: CommuncationSurveyContent[0].name,
      stepNo: -1,
      allSteps
    };

    const match = location.pathname.match(/\/host\/survey\/([\w\-]*)\//);
    const stepName = match?.[1];

    if (stepName) {
      while (!newState.current && newState.stepNo < allSteps) {
        newState.stepNo += 1;
        newState.prevStep = CommuncationSurveyContent[newState.stepNo - 1]?.name ?? '';
        newState.nextStep = CommuncationSurveyContent[newState.stepNo + 1]?.name ?? null;
        if (CommuncationSurveyContent[newState.stepNo]?.name === stepName) {
          newState.current = CommuncationSurveyContent[newState.stepNo];
        }
      }
    }

    setState(newState);
  }, [location]);

  const addResponses = (value) => {
    console.log("addResponses", value);
    const allResponses = { ...responses, ...value };
    console.log("allResponses", allResponses);
    setResponses(allResponses);
    return allResponses;
  }

  return (
    <SurveyContext.Provider value={{ ...state, responses, addResponses, saveResponses: storeResponses }}>{children}</SurveyContext.Provider>
  );
}

export { SurveyContextProvider, useSurveyContext };
